import React from "react";

import { Box, Flex } from "@chakra-ui/react";
import { theme } from "@ovou-inc/ovou-ui";

import type { ICropRatioOption } from "./CropPanel";

interface IRatioSelectorProps {
  options: ICropRatioOption[];
  activeRatio: number;
  onSelect: (ratio: number) => void;
}

const RATIO_GAP = 32;

const RatioSelector: React.FC<IRatioSelectorProps> = ({
  options,
  activeRatio,
  onSelect,
}) => {
  if (!options || options.length < 2) return null;

  return (
    <Flex align="center" justify="center" gap={`${RATIO_GAP}px`}>
      {options.map(option => {
        const isActive = activeRatio === option.ratio;
        const color = isActive
          ? theme.palette.brand.primary.black
          : theme.palette.ui.greys.grey2;
        return (
          <Box
            as="button"
            key={option.ratio}
            type="button"
            display="flex"
            alignItems="center"
            bg="transparent"
            padding={0}
            margin={0}
            border="none"
            color={color}
            boxShadow="none"
            _focus={{ outline: "none", boxShadow: "none" }}
            _focusVisible={{ outline: "none", boxShadow: "none" }}
            onClick={(): void => onSelect(option.ratio)}
          >
            <Box as="span" fontSize="14px" fontWeight={600}>
              {option.label}
            </Box>
            {option.example && (
              <Box
                as="span"
                display="inline-block"
                ml="8px"
                w={`${option.example.width}px`}
                h={`${option.example.height}px`}
                borderWidth="2px"
                borderStyle="solid"
                borderColor={color}
                borderRadius="3px"
              />
            )}
          </Box>
        );
      })}
    </Flex>
  );
};

export default RatioSelector;
